"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dompurify = _interopRequireDefault(require("dompurify"));

var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _Rule = _interopRequireDefault(require("@react/react-spectrum/Rule"));

var _Textfield = _interopRequireDefault(require("@react/react-spectrum/Textfield"));

var _constants = require("../../constants");

var _Link = _interopRequireDefault(require("@react/react-spectrum/Link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LoginForm = function LoginForm(_ref) {
  var existingGuestName = _ref.existingGuestName,
      fireIngestEvent = _ref.fireIngestEvent,
      guestSessionState = _ref.guestSessionState,
      intl = _ref.intl,
      onGuestLogin = _ref.onGuestLogin,
      onLogin = _ref.onLogin,
      reCaptchaEnabled = _ref.reCaptchaEnabled,
      reCaptchaSiteKey = _ref.reCaptchaSiteKey;
  var hasExistingSession = guestSessionState === 'expires-soon' || guestSessionState === 'expired';
  var formatMessage = intl.formatMessage,
      locale = intl.locale;
  var guestCommentingEnabled = !!reCaptchaSiteKey;

  var _useState = (0, _react.useState)(hasExistingSession ? existingGuestName : ''),
      _useState2 = _slicedToArray(_useState, 2),
      name = _useState2[0],
      setName = _useState2[1];

  var reCaptchaRef = (0, _react.useRef)();
  var isRestoringGuestSession = guestSessionState === 'expires-soon' && existingGuestName === name;

  var handleChange = function handleChange(rawName) {
    var sanitizedName = _dompurify.default.sanitize(rawName);

    if (sanitizedName.length <= _constants.DEFAULT_GUEST_NAME_LIMIT) {
      setName(sanitizedName);
    }
  };

  var handleReCaptchaChange = function handleReCaptchaChange(value) {
    var guestUserInfo = {
      captchaSiteKey: reCaptchaSiteKey,
      captchaResponseCode: value,
      userName: name
    };
    onGuestLogin(guestUserInfo, isRestoringGuestSession);
  };

  var handleGuestLogin = function handleGuestLogin() {
    if (name && reCaptchaEnabled) {
      // programmatically invoke the challenge
      reCaptchaRef.current.execute();
    } else {
      handleReCaptchaChange('randomString'); // for UI automation
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    if (event.keyCode === _constants.KEY_CODES.ENTER && !event.shiftKey) {
      handleGuestLogin();
    }
  };

  var handleClick = function handleClick() {
    fireIngestEvent({
      event: {
        subcategory: 'sign-in-guest',
        subtype: 'textbox',
        type: 'click'
      }
    });
  };

  (0, _react.useEffect)(function () {
    fireIngestEvent({
      event: {
        subcategory: 'sign-in',
        subtype: 'sign-in',
        type: 'render'
      }
    });
  }, [fireIngestEvent]);
  var adobeTOULink = formatMessage({
    id: 'comments.login.guest.adobe-tou-url'
  });
  var adobePrivacyLink = formatMessage({
    id: 'comments.login.guest.adobe-privacy-url'
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "login-dialog-content"
  }, !guestCommentingEnabled && /*#__PURE__*/_react.default.createElement("p", {
    className: "login-dialog-description"
  }, formatMessage({
    id: 'comments.login.description'
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    id: "ccx-comments-login-signin",
    onClick: onLogin,
    label: formatMessage({
      id: 'comments.login.sign_in'
    }),
    variant: "cta"
  })), guestCommentingEnabled && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "ccx-comments-login-rule"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement(_Rule.default, {
    variant: "medium"
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "ccx-comments-login-rule-text"
  }, formatMessage({
    id: 'comments.login.rule'
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement(_Rule.default, {
    variant: "medium"
  }))), /*#__PURE__*/_react.default.createElement("h3", {
    className: "ccx-comments-login-guest-header"
  }, formatMessage({
    id: 'comments.login.guest.header'
  })), /*#__PURE__*/_react.default.createElement(_Textfield.default, {
    id: "ccx-comments-login-guest-input",
    placeholder: formatMessage({
      id: 'comments.login.guest.placeholder'
    }),
    onChange: handleChange,
    onClick: handleClick,
    onKeyUp: handleKeyUp,
    defaultValue: hasExistingSession ? existingGuestName : undefined
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "adobe-legal-notice"
  }, formatMessage({
    id: 'comments.login.guest.adobe-tou'
  }, {
    tou: function tou(txt) {
      return /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: adobeTOULink,
        target: "_blank",
        rel: "noreferrer"
      }, txt);
    },
    // eslint-disable-line react/display-name
    privacy: function privacy(txt) {
      return /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: adobePrivacyLink,
        target: "_blank",
        rel: "noreferrer"
      }, txt);
    } // eslint-disable-line react/display-name

  })), reCaptchaEnabled && /*#__PURE__*/_react.default.createElement("div", {
    id: "recaptcha-container"
  }, /*#__PURE__*/_react.default.createElement(_reactGoogleRecaptcha.default, {
    ref: reCaptchaRef,
    size: "invisible",
    sitekey: reCaptchaSiteKey,
    onChange: handleReCaptchaChange,
    hl: locale
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "login-btn-container"
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    disabled: !name,
    id: "ccx-comments-login-guest-submit",
    label: formatMessage({
      id: 'comments.login.guest.submit'
    }),
    onClick: handleGuestLogin
  })), /*#__PURE__*/_react.default.createElement(_Rule.default, {
    variant: "medium"
  }), reCaptchaEnabled && /*#__PURE__*/_react.default.createElement("div", {
    className: "google-legal-notice"
  }, formatMessage({
    id: 'comments.login.guest.google-tou'
  }, {
    tou: function tou(txt) {
      return /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: "https://policies.google.com/terms?hl=".concat(locale),
        target: "_blank",
        rel: "noreferrer"
      }, txt);
    },
    // eslint-disable-line react/display-name
    privacy: function privacy(txt) {
      return /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: "https://policies.google.com/privacy?hl=".concat(locale),
        target: "_blank",
        rel: "noreferrer"
      }, txt);
    } // eslint-disable-line react/display-name

  }))));
};

LoginForm.defaultProps = {
  reCaptchaEnabled: true
};
LoginForm.propTypes = {
  existingGuestName: _propTypes.default.string,
  fireIngestEvent: _propTypes.default.func,
  guestSessionState: _propTypes.default.string,
  intl: _propTypes.default.shape({
    formatMessage: _propTypes.default.func,
    locale: _propTypes.default.string
  }).isRequired,
  onGuestLogin: _propTypes.default.func.isRequired,
  onLogin: _propTypes.default.func.isRequired,
  reCaptchaEnabled: _propTypes.default.bool,
  reCaptchaSiteKey: _propTypes.default.string
};
var _default = LoginForm;
exports.default = _default;